module.exports = __webpack_public_path__ + "img/feedback.c02f7440.svg";